export enum AnnotationFormatType {
    YOLO = 'YOLO',
    COCO = 'COCO',
    CSV = 'CSV',
    JSON = 'JSON',
    VOC = 'VOC',
    VGG = 'VGG',
    PPOCR = 'PPOCR',
    RANK = 'RANK'
}

export enum ExportDataFormatType {
    YOLOData = 'YOLOData',
    PPOCRData = 'PPOCRData'
}